import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  FormControl,
  FormLabel,
  Chip,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { SoapAssessment } from '../../types/soap';

interface AssessmentSectionProps {
  data: SoapAssessment;
  onChange: (data: SoapAssessment) => void;
  disabled?: boolean;
}

const AssessmentSection: React.FC<AssessmentSectionProps> = ({
  data,
  onChange,
  disabled = false,
}) => {
  const handleAISummaryChange = (value: string) => {
    onChange({
      ...data,
      aiSummary: value,
    });
  };

  return (
    <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormControl fullWidth>
          <FormLabel sx={{ mb: 0.5, fontSize: '0.875rem', fontWeight: 'bold' }}>
            Assessment
          </FormLabel>
          <TextField
            multiline
            rows={10}
            fullWidth
            value={data.aiSummary || ''}
            onChange={(e) => handleAISummaryChange(e.target.value)}
            disabled={disabled}
            placeholder="Enter assessment findings here"
            variant="outlined"
            sx={{
              '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                lineHeight: 1.6,
              },
            }}
          />
        </FormControl>
      </Box>
    </Paper>
  );
};

export default AssessmentSection;
